import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import BLASTModal, {StepKey} from 'search/blast/BLASTModal';
import {BlastModalTrigger, trackBlastModalOpen} from 'search/blast/BLASTTracking';
import {BLASTFilter, Filter, FilterKey, SearchParams} from 'search/SearchConstants';
import Chip, {ChipSize} from 'ui-library/chips/Chip';
import {BLUE_LIGHT, BLUE_POWDER, NEAR_BLACK, ORANGE_POWDER} from 'ui-library/Colors';
import runModal from 'ui-library/runModal';

import {mergeBLASTFilter} from './BLASTUtil';

export interface BLASTChipProps {
  className?: string;
  onUpdateFilters: (filters: Array<Filter>) => void;
  BLASTFilter: BLASTFilter;
  searchParams: SearchParams;
  filterError: string | null;
}

export default function BLASTChip({
  className,
  onUpdateFilters,
  BLASTFilter,
  searchParams,
  filterError,
}: BLASTChipProps): JSX.Element {
  return (
    <Chip
      className={classNames(
        filterError ? css(styles.chipInvalid) : css(styles.chipValid),
        css(styles.chip),
        className
      )}
      size={ChipSize.TABLE_CELL}
      text="BLAST"
      icon="helix"
      key="BLASTChip"
      onClick={() => {
        trackBlastModalOpen(BlastModalTrigger.BLAST_SEARCH);
        runModal(BLASTModal, {
          initialFilter: BLASTFilter,
          onRequestClose: () => {},
          onRequestSubmit: (newFilter: BLASTFilter): void => {
            onUpdateFilters(mergeBLASTFilter(searchParams, newFilter).filters);
          },
          currentStep: StepKey.SetParameters,
        });
      }}
      onRemove={() => {
        onUpdateFilters(searchParams.filters.filter((filter) => filter.key !== FilterKey.BLAST));
      }}
      tooltipTitle={filterError}
    />
  );
}

const styles = StyleSheet.create({
  chip: {
    marginRight: '0px',
  },
  chipValid: {
    backgroundColor: BLUE_POWDER,
    color: BLUE_LIGHT,
  },
  chipInvalid: {
    backgroundColor: ORANGE_POWDER,
    color: NEAR_BLACK,
  },
});
